export default __webpack_public_path__ + "resources/icons/d410-b2d0.webp";